/* eslint-disable consistent-return */
import "./index.scss";
import "../../locales/i18n";

import * as moment from "moment-timezone";
import React, { useEffect,useState } from "react";
import { useHistory } from "react-router-dom";

import { TDropdownOption } from "@/components/components/Dropdown/dropdown.type";
import { CHAT } from "@/messenger/constants/routing";

import Attributes from "../Attributes";
import { getBranchesHandler, getBranchIds, getBranchNames, getDefaultTimezone } from "../helper";
import TermsAndConditions from "../TermsAndConditions";

export interface TUserMetadata {
    timezone: string;
    branch: Array<any>;
    wasFirstLoggedIn: boolean;
}

export enum TFirstLoginPages {
    termsAndConditions = "termsAndConditions",
    timezones = "timezones",
    branchSelector = "branchSelector",
}

interface TFirstLoginProps {
    updateMetadata?: (m: any) => void;
    userMetadata?: TUserMetadata;
    initialCurrentPage?: TFirstLoginPages;
}

const FirstLogin = (props: TFirstLoginProps) => {

    const history = useHistory();

    const [timezone, setTimezone] = useState<string>(null);
    const [branch, setBranch] = useState<string[]>([]);

    const [branches, setBranches] = useState<TDropdownOption[]>(null);

    const [error, setError] = useState<string>(null);
    const timezones: { label: string; heading: string }[] = moment.tz.names().map(z => ({ label: z, heading: z }));
    const [currentPage, setCurrentPage] = useState<TFirstLoginPages>(TFirstLoginPages.timezones);

    const onTimezoneSelect = (tz: TDropdownOption) => {
        setTimezone(tz.label);
    };

    const onBranchSelect = (br: TDropdownOption) => {
        setError(null);
        const updatedBranch = [...branch];

        if (updatedBranch.includes(br.label)) {
            const i = updatedBranch.indexOf(br.label);
            updatedBranch.splice(i, 1);
        } else {
            updatedBranch.push(br.label);
        }

        setBranch(updatedBranch);
    };

    const onContinue = () => {
        if (currentPage === TFirstLoginPages.termsAndConditions) {
            setCurrentPage(TFirstLoginPages.timezones);
            return;
        }
        setCurrentPage(TFirstLoginPages.branchSelector);
    };

    const onAccept = () => {
        if (branch.length === 0) {
            setError("Please select at least one branch");
            return;
        }

        const branchIds = getBranchIds(branches, branch);

        finalizeLogin(branchIds);
    };

    const selectedTimezoneOption = timezone ? {
        label: timezone,
        heading: timezone,
    } : null;

    const selectedBranchOptions: TDropdownOption[] = branch?.map((item) => ({
        label: item,
        heading: item,
    }));

    const finalizeLogin = (branchIds: any[]) => {
        const userMetadata: TUserMetadata = {
            wasFirstLoggedIn: true,
            timezone,
            branch: branchIds,
        };

        props.updateMetadata(userMetadata);
        
        setTimeout(() => {
            if(props.initialCurrentPage === TFirstLoginPages.branchSelector) history.push(`/${CHAT}`);
        }, 1000);
        
    };

    const setBranchHandler = (branchList: any[]) => {
        const selectedList = [];
        props.userMetadata?.branch?.forEach(item => {
            const name = getBranchNames(branchList, item);
            if (name) {
                selectedList.push(name);
            }
        });
        setBranch(selectedList);
    };

    const onClose = () => {
        history.push(`/${CHAT}`);
    };

    useEffect(() => {
        if (props.initialCurrentPage) {
            setCurrentPage(props.initialCurrentPage);
        } else {
            setCurrentPage(TFirstLoginPages.termsAndConditions);
        }

        (async () => {
            const data = await getBranchesHandler();
            setBranches(data);
        })();

        const defaultUserTimezone = getDefaultTimezone();
        setTimezone(props?.userMetadata?.timezone || defaultUserTimezone);
    }, []);

    useEffect(() => {
        if (props.updateMetadata && props.userMetadata?.branch) {
            if(branches) setBranchHandler(branches);
        }
    }, [props.userMetadata, branches]);


    const renderScreen = () => {
        if (currentPage === TFirstLoginPages.termsAndConditions) {
            return <TermsAndConditions onClick={onContinue} />;
        }
        if (currentPage === TFirstLoginPages.timezones) {
            return <Attributes
                title={"Time-zone"}
                options={timezones}
                mode="first"
                selectedOption={selectedTimezoneOption}
                onSelect={onTimezoneSelect}
                onClick={branches?.length > 0 ? onContinue : () => finalizeLogin([])}
            />;
        }
        if (currentPage === TFirstLoginPages.branchSelector && branches?.length > 0) {
            return <Attributes
                multiple
                error={error}
                title={"Branch(es)"}
                options={branches?.filter((item) => !branch?.includes(item.label))}
                selectedOptions={selectedBranchOptions}
                onSelect={onBranchSelect}
                onClick={onAccept}
                onClose={props.initialCurrentPage === TFirstLoginPages.branchSelector ? onClose : null}
            />;
        }
        return null;
    };

    return (
        <div className="p-first-login">
            {renderScreen()}
        </div>
    );
};

export default FirstLogin;
